import React  from "react";
import {XSpan} from "../../Layout/Layout";

export default function render(value,props) {
    let res;
    res=<XSpan {...props}   >{value}</XSpan>;
    return res;
}